export const REPORT_LIST_REQUEST = "REPORT_LIST_REQUEST";
export const REPORT_LIST_SUCCESS = "REPORT_LIST_SUCCESS";
export const REPORT_LIST_FAIL = "REPORT_LIST_FAIL";

export const DETAIL_REPORT_REQUEST = "DETAIL_REPORT_REQUEST";
export const DETAIL_REPORT_SUCCESS = "DETAIL_REPORT_SUCCESS";
export const DETAIL_REPORT_FAIL = "DETAIL_REPORT_FAIL";
